import { render, staticRenderFns } from "./OrganizationManage.vue?vue&type=template&id=18bcf957&scoped=true&"
import script from "./OrganizationManage.vue?vue&type=script&lang=js&"
export * from "./OrganizationManage.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationManage.vue?vue&type=style&index=0&id=18bcf957&prod&scoped=true&lang=css&"
import style1 from "./OrganizationManage.vue?vue&type=style&index=1&id=18bcf957&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bcf957",
  null
  
)

export default component.exports